var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReportsWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.6673 7.24967V15.833C16.6673 17.6663 15.1673 19.1663 13.334 19.1663H6.66732C4.83398 19.1663 3.33398 17.6663 3.33398 15.833V4.16634C3.33398 2.33301 4.83398 0.833008 6.66732 0.833008H10.2507C11.1673 0.833008 12.0006 1.16634 12.584 1.83301L15.6673 4.91634C16.334 5.49967 16.6673 6.333 16.6673 7.24967Z",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6667 7.49967H11.6667C10.75 7.49967 10 6.74967 10 5.83301V0.833008",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReportsWhite);
export default __webpack_public_path__ + "static/media/Reports_White.29ce12412e31436498f85e049e6fc457.svg";
export { ForwardRef as ReactComponent };